module.exports = __webpack_public_path__ + "static/media/img_nookpoint_many.1db8ea9b.svg";